import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.js";

import { ContextProvider } from "./context/ContextProvider";
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration.js";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <ContextProvider>
    <I18nextProvider i18n={i18n}>
    <App />
    </I18nextProvider>
  </ContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
const path = window.location.pathname.slice(1);
const isShortCode = /^[a-zA-Z0-9]{4,5}$/.test(path);

if (!isShortCode) {
    serviceWorkerRegistration.register();
}
//serviceWorkerRegistration.register();
reportWebVitals();
